import { render, staticRenderFns } from "./ClaimForm.vue?vue&type=template&id=b2c51184&scoped=true&"
import script from "./ClaimForm.vue?vue&type=script&lang=js&"
export * from "./ClaimForm.vue?vue&type=script&lang=js&"
import style0 from "./ClaimForm.vue?vue&type=style&index=0&id=b2c51184&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c51184",
  null
  
)

export default component.exports